/**
 * @desc 根据父ID查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BuSbuModel>>;
export function request(parentId: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/buSbu/list/parent/${parentId}`, {
      method: "GET",

      ...options,
    }),
  );
}
